import React from 'react';
import { Link } from 'react-router-dom';
import DropdownNotification from './dropdown/notification.jsx';
import DropdownChat from './dropdown/chat.jsx';
import DropdownLanguage from './dropdown/language.jsx';
import DropdownProfile from './dropdown/profile.jsx';
import SearchForm from './search/form.jsx';
import DropdownMegaMenu from './dropdown/mega.jsx';
import DropdownApps from './dropdown/apps.jsx';
import { Icon } from '@iconify/react';

import { AppSettings } from './../../config/app-settings.js';

function Header() {
	return (
		<AppSettings.Consumer>
			{({toggleAppSidebarMobile, toggleAppTopNavMobile, appHeaderMegaMenu, appHeaderInverse, appTopNav, appSidebarNone}) => (
					<div id="appHeader" className="app-header" data-bs-theme={appHeaderInverse ? 'dark' : undefined}>
						<div className="brand">
							<div className="mobile-toggler">
								{!appSidebarNone && <button type="button" className="menu-toggler" onClick={toggleAppSidebarMobile} aria-label="Toggle sidebar">
									<span className="icon-bar"></span><span className="icon-bar"></span>
								</button>}
								{appSidebarNone && appTopNav && <button type="button" className="menu-toggler" onClick={toggleAppTopNavMobile} aria-label="Toggle top nav">
									<span className="icon-bar"></span><span className="icon-bar"></span>
								</button>}
							</div>
							<Link to="/" className="brand-logo"><span className="brand-icon"></span><span className="fw-bolder me-3px">Color</span> Admin</Link>
						</div>
						<div className="menu">
							{appTopNav && <div className="menu-item d-md-none"><a href="#/" data-toggle="app-top-nav-mobile" className="menu-link" onClick={toggleAppTopNavMobile}><Icon icon="solar:add-square-line-duotone" /></a></div>}
							{appHeaderMegaMenu ? <DropdownMegaMenu /> : <SearchForm />}
							{appHeaderMegaMenu && <SearchForm />}
							<DropdownApps />
							<DropdownNotification />
							<DropdownChat />
							<DropdownLanguage />
						<DropdownProfile />
						</div>
					</div>
			)}
		</AppSettings.Consumer>
	)
}

export default Header;
